// extracted by mini-css-extract-plugin
export default {"wrapper":"ScoreGauge_wrapper__bZUJQ","label":"ScoreGauge_label__L3TFz","number":"ScoreGauge_number__MVJ5H","max":"ScoreGauge_max__fT8GE"};